import React from 'react'
import { IUseOrder } from '../hooks/useOrder'

export const OrderContext = React.createContext<IUseOrder>(null)
